/**
 * Progress bar
 */

let timer;
let reset_timeout;
let next_timeout;
let finish_loader;
let start_timer;

const state = {
    progressLoaderWidth: 0,
    i: 0,
};

const getters = {
    progressLoaderWidth: (state) => {
        return state.progressLoaderWidth;
    },
};

const actions = {
    showLoader({ commit, state, dispatch }) {
        //these should always happen first to reset the loader
        //remove the classes and set the width to 0 before the animation starts
        $("#progress-loader").removeClass("reset transition");
        commit("RESET");

        clearTimeout(reset_timeout); // clear the remove loader timeout
        clearTimeout(next_timeout); // clear the timeout to set the width to 0, if this isn't in a setTimeout it will show it animate to 0
        clearTimeout(start_timer); // clear the increment timer on startup
        clearTimeout(finish_loader); // clear any instance of the finish loader function that has started
        clearInterval(timer); // clear the incrementing interval

        //animation starts here
        start_timer = setTimeout(() => {
            $("#progress-loader").addClass("transition");
            commit("COUNTUP5"); // the first initial increment

            //start incrementing after half a second
            timer = setInterval(() => {
                commit("COUNTI");
                // stop incrementing if it reaches a certain point
                if (state.i > 49) clearInterval(timer);

                // the amount it increments
                commit("COUNTUP2");
            }, 400);
        }, 25);
    },
    hideLoader({ commit, state, dispatch }) {
        clearTimeout(finish_loader); // clear any instance of the finish loader function that has started

        //finish the loader and remove it from the dom
        finish_loader = setTimeout(() => {
            clearTimeout(start_timer); // clear the increment timer on startup
            clearInterval(timer); // clear the incrementing interval
            commit("COUNTFULL");

            //add the reset class and remove it from the dom, they need to be in seperate timeouts otherwise it will just disappear with no effect
            //opacity turns to 0 then it gets removed
            reset_timeout = setTimeout(() => {
                $("#progress-loader").addClass("reset");
                next_timeout = setTimeout(() => {
                    //gets removed from dom here
                    $("#progress-loader").removeClass("transition");
                    commit("RESET");
                }, 300);
            }, 600);
        }, 10);
    },
};

const mutations = {
    //startLoader(state) {},

    //finishLoader(state) {},
    RESET(state) {
        state.i = 5;
        state.progressLoaderWidth = 0;
    },
    COUNTUP2(state) {
        state.progressLoaderWidth = state.i * 2;
        //state.progressLoaderWidth = state.progressLoaderWidth + 2;
    },
    COUNTUP5(state) {
        state.progressLoaderWidth = state.progressLoaderWidth + 5;
    },
    COUNTFULL(state) {
        state.progressLoaderWidth = 100; // finish the load animation
    },
    COUNTI(state) {
        state.i = state.i + 1;
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
